import * as React from 'react';
import { cn } from '@/lib/utils';

export interface PageHeaderProps {
  /** h1 страницы (Onest 28/800). */
  title: React.ReactNode;
  /** Подзаголовок под h1 (text-2). */
  subtitle?: React.ReactNode;
  /** Кнопки/переключатели справа (на узком экране переносятся вниз). */
  actions?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, subtitle, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-wrap items-end justify-between gap-3', className)}>
      <div className="flex min-w-0 flex-col gap-1">
        <h1 className="m-0 font-display text-[28px] font-extrabold leading-tight tracking-[-0.01em] text-text">
          {title}
        </h1>
        {subtitle && <div className="text-sm text-text-2">{subtitle}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2.5">{actions}</div>}
    </div>
  );
}
